import { connect } from "react-redux";

import { getJobConflictList } from "../jobsActions";
import JobConflictSidePanel from "./JobConflictSidePanel";

const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  jobConflictList: state.jobs.jobConflictList,
  jobConflictListIsLoading: state.jobs.isLoadingJobConflictList,
});

const mapDispatchToProps = dispatch => ({
  getJobConflictList: params => dispatch(getJobConflictList(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(JobConflictSidePanel);
